import { useContext } from "react";
import { NotificationContext } from "../contexts/NotificationsContext";

export function useNotificationContext() {
  return useContext(NotificationContext);
}
